module.exports = __webpack_public_path__ + "img/bim2.be6d8c34.png";